const ALLOWED_NAME_CHARS = /[^a-zA-Z0-9!@#$%^&*()\-_=+\[\]{}|;:'",.<>]/g;

function formatFinanceAttachmentDate(date = new Date()) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}${m}${d}`;
}

function getFileExtension(name: string) {
  const match = name.match(/(\.[a-zA-Z0-9]+)$/);
  return match ? match[1].toLowerCase() : '';
}

export function buildFinanceAttachmentStoredName(originalName: string, uploaderAccount = '') {
  const date = formatFinanceAttachmentDate();
  const userIdCopy = String(uploaderAccount || 'user').slice(0, 5) || 'user';
  const ext = getFileExtension(originalName);
  const baseName = ext ? originalName.slice(0, -ext.length) : originalName || 'file';

  let sanitized = baseName.replace(ALLOWED_NAME_CHARS, '');
  if (!sanitized) {
    sanitized = 'file';
  }

  const regexSlice = sanitized.slice(-15) || 'file';
  return `${date}${userIdCopy}_${regexSlice}${ext}`;
}

export function renameFinanceAttachmentFile(file: File, uploaderAccount: string) {
  const storedName = buildFinanceAttachmentStoredName(file.name, uploaderAccount);
  return new File([file], storedName, { type: file.type, lastModified: file.lastModified });
}
